import * as yup from 'yup'

/** Схема формы ввода имени пользователя (при регистрации). */
export const nameSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(1, 'Введите имя')
    .max(128, 'Максимум 128 символов')
    .required('Введите имя')
})

export type NameFormValues = yup.InferType<typeof nameSchema>
